import {useLocale, useTranslation} from '#imports';
import {buildDefaultLocationSuggestions} from '../utils/buildDefaultLocationSuggestions';
import type {LocationSuggestion} from '../types/custom';
import {useGlobalMatching} from './useGlobalMatching';

function useDefaultLocationSuggestions() {
    const {countryCode} = useLocale();
    const {t} = useTranslation();

    const {isBrowsingGlobalMatching} = useGlobalMatching();

    async function getDefaultLocationSuggestions(remoteCountryLabel?: string | null): Promise<LocationSuggestion[]> {
        const suggestions = await buildDefaultLocationSuggestions({
            remoteLabel: remoteCountryLabel,
            globalMatching: isBrowsingGlobalMatching.value ?? false,
            countryCode: countryCode?.value,
            buildCountrySelectLabel: (label: string) => t('search.location.com.user.country.select.label' as any, [label]),
        });

        return suggestions;
    }

    return {getDefaultLocationSuggestions};
}

export default useDefaultLocationSuggestions;
